import {useState} from 'react';
import titleIconOne from '../../media/img/lab/robot-building.png';
import gitLab from '../../media/img/lab/github.png';

function ResearchDevelopment() {
  return(
    <section className="r-and-d pos-rel">
      <div className="research-title">
        <img src={titleIconOne} className="title-icon"></img>
        <h3>Research and Development</h3>
      </div>
      <h5>Description:</h5>
      <div className="flex space-between">
        <div>
        <p className="w-400px mb-10">
          Here you can find lists of the topics, both completed and planning, and the programs I create in my studies. All materials will be on the public GitHub repository. 
        </p>
        <a 
          href="https://github.com/dave-sommerville/eternal-september-labs/blob/main/Upcoming%20R%26D.txt" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="indent">
            Upcoming R&D
        </a>
        </div>
        <div className="f-col center">
          <a href="https://github.com/dave-sommerville/eternal-september-labs" target="_blank" rel="noopener noreferrer">
            <img src={gitLab} className="gitlab"></img>
          </a>
        <p>
          Github
        </p>
        <p>
          Repository
        </p>
        </div>
      </div>
      <div className="flex space-between">

      <div className="research">
        <h4>Research</h4>
        <ul>
          <li className="bold">Studies:</li>
          <li className="indent">*Coming Soon</li>
          <li className="indent mb-10">LLM Coding Competition</li>
          <li className="bold">New Tech Stack:</li>
          <li className="indent">GraphRag</li>
          <li className="indent">Docker</li>
          <li className="indent mb-10">LangChain</li>
        </ul>
      </div>
      <div className="development">
        <h4>Development</h4>
        <ul>
          <li className="bold">Programs:</li>
          <li className="indent">
            <a 
              href="https://github.com/dave-sommerville/eternal-september-labs/tree/main/Development/3SCRIPTs3BOTs"
              target="_blank" 
              rel="noopener noreferrer" 
            >
              3SCRIPTs3BOTs
            </a>
          </li>
        </ul>
      </div>
      </div>
    </section>
  );
}
export default ResearchDevelopment;